module.exports = __webpack_public_path__ + "978bbed743f982bb7f985155a517ddad.jpg";